var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionDiscountEvent } from "./actionDiscountEvent";
var initial = {
    hideActionButtons: new Set(),
    selectedEventId: undefined,
};
export var reducerDiscountEvent = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionDiscountEvent.SelectEvent:
            return __assign({}, state, { selectedEventId: action.eventId });
        case TypeActionDiscountEvent.ActionButtonHide:
            return __assign({}, state, { hideActionButtons: new Set(Array.from(state.hideActionButtons).concat([
                    action.eventId,
                ])) });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/reducerDiscountEvent.ts
// module id = 2524
// module chunks = 3